import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Field, ErrorMessage } from "formik";
import { ListItem, Card, CardActions, IconButton, CardMedia, Grid, FormHelperText } from "@material-ui/core";
import { ExpandMore, ArrowBack, Delete, Save, ChevronRight } from "@material-ui/icons";
import { Button } from "..";
import { TextField } from "@ploy-ui/form-fields";
import { UnsavedChangesCard } from "./UnsavedChangesCard";
import isEqual from "lodash/isEqual";
export function ExpandableElement(props) {
    const { index, elementIdKey, element, elementConfig, isExpandable, collapsedElement = SmallElement, initialOpen, isSelected, setSelected, onSave, onDelete, editSingle, margin, formValue, setFormValues, errors = false, useThemedButtons, closeRequest, isNewElement, canDelete, removeElementFromForm, divider = true, autofillFunction, columns = 3, canSave = true, showErrorMessages = false } = props;
    const [open, setOpen] = useState(initialOpen);
    const prefix = editSingle ? "" : `elements.${index}.`;
    !editSingle && errors && !open && setOpen(true);
    const [unsavedChanges, setUnsavedChanges] = useState(closeRequest ? true : false);
    if (closeRequest &&
        isSelected &&
        formValue === element &&
        isNewElement &&
        !isNewElement(element)) {
        closeRequest.closeCallback();
    }
    return (_jsxs(_Fragment, { children: [editSingle && (_jsx(UnsavedChangesCard, { open: closeRequest !== undefined || unsavedChanges, onCancel: () => {
                    setUnsavedChanges(false);
                    closeRequest && closeRequest.cancelCallback();
                }, onDiscard: () => {
                    setFormValues && setFormValues(element);
                    setUnsavedChanges(false);
                    setOpen(false);
                    setSelected && setSelected(undefined);
                    closeRequest && closeRequest.closeCallback();
                    if (isNewElement && isNewElement(element)) {
                        removeElementFromForm &&
                            removeElementFromForm(formValue || element, index);
                    }
                } })), !isExpandable || open || isSelected ? (_jsx(ListItem, { divider: !editSingle || (!open && !isSelected && isExpandable), children: _jsxs(Card, { elevation: 0, style: { width: "100%" }, children: [!editSingle && isExpandable && (_jsx(CardActions, { children: _jsx(FormButton, { onClick: () => {
                                    setOpen(false);
                                    setSelected && setSelected(undefined);
                                }, Icon: ExpandMore }) })), _jsx(CardMedia, { style: { margin: "25px" }, children: _jsx(Grid, { item: true, container: true, spacing: 2, children: elementConfig.map((configElement, i) => {
                                    const hidden = typeof configElement.hidden === "function"
                                        ? configElement.hidden(element)
                                        : configElement.hidden || false;
                                    return (!hidden && (_jsxs(Grid, { xs: 12, md: Math.max(6, 12 / columns), lg: (12 / columns), item: true, style: {
                                            marginTop: !isExpandable ? "30px" : undefined
                                        }, children: [_jsx(Field, { name: prefix + configElement.name, component: configElement.render || CustomField, configElement: configElement, autofillFunction: autofillFunction, margin: margin, disabled: typeof configElement.disabled === "function"
                                                    ? configElement.disabled(element)
                                                    : configElement.disabled || false }), showErrorMessages && (_jsx(ErrorMessage, { name: prefix + configElement.name, render: errorMessage => (_jsx(FormHelperText, { error: true, children: errorMessage })) }))] }, configElement.name)));
                                }) }) }), _jsxs(CardActions, { style: { marginLeft: "20px", marginRight: "20px" }, children: [editSingle && (_jsx(FormButton, { onClick: () => {
                                        if (editSingle &&
                                            (!isEqual(formValue, element) ||
                                                (isNewElement && isNewElement(element)))) {
                                            setUnsavedChanges(true);
                                        }
                                        else {
                                            setOpen(false);
                                            setSelected && setSelected(undefined);
                                        }
                                    }, Icon: ArrowBack, tennantTheme: useThemedButtons ? "primary" : undefined, style: { marginRight: "auto" } })), (canDelete || !editSingle) && (_jsx(FormButton, { onClick: () => {
                                        onDelete && onDelete(element, index);
                                        setSelected && setSelected(undefined);
                                        setOpen(false);
                                    }, Icon: Delete, tennantTheme: useThemedButtons ? "secondary" : undefined })), onSave && canSave && (_jsx(FormButton, { onClick: onSave, Icon: Save, tennantTheme: useThemedButtons ? "secondary" : undefined }))] })] }) }, `listItem.${element[elementIdKey]}`)) : (_jsx(ListItem, { divider: divider, button: true, onClick: () => {
                    !open && setOpen(true);
                    setSelected && setSelected(element[elementIdKey]);
                }, children: collapsedElement(element) }, `listItem.collapsed.${element[elementIdKey]}`))] }));
}
const CustomField = ({ configElement, autofillFunction, field, form, onBlur, ...props }) => (_jsx(TextField, { label: configElement.title, field: field, form: form, fullWidth: true, meta: { value: field.value, touched: false, initialTouched: false }, onBlur: configElement.autofillKey && autofillFunction ? autofillFunction : onBlur, ...props }));
const SmallElement = values => {
    return (_jsx(Grid, { container: true, children: _jsx(ChevronRight, {}) }));
};
function FormButton(props) {
    const { onClick, Icon, tennantTheme, style } = props;
    const [smallScreen, setSmallScreen] = useState(window.innerWidth < 410);
    useEffect(() => {
        const handleResize = () => {
            setSmallScreen(window.innerWidth < 410);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const dynamicStyle = {
        ...style,
        padding: smallScreen ? "3px 8px" : "",
        minWidth: smallScreen ? "0px" : ""
    };
    return tennantTheme ? (_jsx(Button, { style: dynamicStyle, color: tennantTheme, variant: "contained", onClick: onClick, children: _jsx(Icon, {}) })) : (_jsx(IconButton, { style: dynamicStyle, onClick: onClick, children: _jsx(Icon, {}) }));
}
//# sourceMappingURL=ExpandableElement.js.map